import { VesselProductMessage } from '../../../../types/VesselProductMessage';
import { translate } from '../../../common/helpers/translate.helper';
import { useUpdateVesselProduct } from '../hooks/useUpdateVesselProduct';

import { VesselProductModal } from './VesselProductModal';

interface EditVesselProductModalProps {
    isOpen: boolean;
    onDismiss: () => void;
    vesselId: string;
    vesselProduct: VesselProductMessage;
    excludedProductIds: string[];
}

export const EditVesselProductModal = ({
    isOpen,
    onDismiss,
    vesselId,
    vesselProduct,
    excludedProductIds,
}: EditVesselProductModalProps) => {
    const updateMutation = useUpdateVesselProduct(vesselId);

    const handleSubmit = async (values: { productId: string; note: string }) => {
        const trimmedNote = values.note.trim();
        await updateMutation.mutateAsync({
            vesselProductId: vesselProduct.id,
            vesselProduct: {
                productId: values.productId,
                note: trimmedNote || undefined,
            },
        });
    };

    return (
        <VesselProductModal
            isOpen={isOpen}
            onDismiss={onDismiss}
            onSubmit={handleSubmit}
            initialValues={{
                productId: vesselProduct.productId,
                note: vesselProduct.note || '',
            }}
            title={translate('vessel.products.editModal.title')}
            isLoading={updateMutation.isPending}
            vesselId={vesselId}
            excludedProductIds={excludedProductIds}
        />
    );
};
